<template>
  <div class="page-wrapper">
    <div class="contents">
      <Steps :current="current">
        <Step title="步骤1"></Step>
        <Step title="步骤2"></Step>
        <Step title="步骤3"></Step>
        <Step title="步骤4"></Step>
      </Steps>

    </div>



  </div>

</template>

<script>
  export default {
    name: "Phone",
    data(){
      return {
        current:0,

      }
    }

  }
</script>

<style scoped>
  /*.contents{*/
    /*width: 80%;*/
  /*}*/

</style>
